/**
 * Agrega el nombre del producto al mensaje del boton de WhatsApp (app Dondy).
 *
 * Dondy arma el enlace wa.me con un mensaje fijo para toda la tienda, asi que la
 * asesora no sabia de que producto venia el cliente. theme.liquid pasa el titulo
 * del producto en data-product-title y aqui se reescribe el enlace del boton:
 * - si el mensaje trae "{producto}" o "(Dinos que producto)", se reemplaza por el nombre;
 * - si no, se agrega al final una linea "Producto: ...".
 */
(function () {
  const source = document.querySelector('script[data-product-title]');
  const productName = source ? source.dataset.productTitle.trim() : '';
  if (!productName) return;

  const LINKS = '#whatsapp-widget-root a[href]';
  const rewritten = new WeakMap();

  function buildMessage(message) {
    // Funcion como reemplazo para que "$&" o "$$" dentro del titulo no se interpreten.
    const withToken = message.replace(/\{producto\}/gi, () => productName);
    if (withToken !== message) return withToken;

    const withName = message.replace(/\s*\(\s*dinos\s+qu[eé]\s+producto\s*\)/i, () => ': ' + productName);
    if (withName !== message) return withName;

    return message + '\nProducto: ' + productName;
  }

  function rewrite(link) {
    const href = link.getAttribute('href');
    if (!href || rewritten.get(link) === href) return;

    try {
      // Solo se toca el parametro text; el resto del enlace (telefono, etc.) queda tal cual.
      const queryStart = href.indexOf('?');
      if (queryStart === -1) return;

      let found = false;
      const query = href
        .slice(queryStart + 1)
        .split('&')
        .map((param) => {
          if (param.indexOf('text=') !== 0) return param;
          found = true;
          const message = decodeURIComponent(param.slice(5).replace(/\+/g, ' '));
          return 'text=' + encodeURIComponent(buildMessage(message));
        })
        .join('&');
      if (!found) return;

      link.href = href.slice(0, queryStart + 1) + query;
      rewritten.set(link, link.getAttribute('href'));
    } catch (e) {
      // Si el enlace no se puede interpretar, queda como lo dejo la app.
    }
  }

  function rewriteAll() {
    document.querySelectorAll(LINKS).forEach(rewrite);
  }

  // La burbuja se dibuja despues de cargar su configuracion y la app puede volver a pintarla.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      rewriteAll();
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

  // Respaldo: justo antes de abrirse el chat, el enlace ya lleva el nombre.
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest && event.target.closest(LINKS);
      if (link) rewrite(link);
    },
    true
  );

  rewriteAll();
})();
